export default "__VITE_ASSET__DAoJNDNw__"